// updaters/HeatmapUpdater.ts
import type { Map as MapType } from "maplibre-gl";
import type { MapUpdater, UpdaterContext } from "./types";
import type { HeatmapPoint } from "../types";
import type { HeatmapManager } from "../managers/heatmap/HeatmapManager";

export class HeatmapUpdater implements MapUpdater {
  readonly name = "heatmap";
  readonly topics = ["skopa/heatmap:batch"];

  private heatmapManager: HeatmapManager | null = null;

  constructor(private ctx: UpdaterContext) {}

  async initialise(map: MapType) {
    console.log("[HeatmapUpdater] Initializing...");
  }

  // Called by MapEngine once HeatmapManager is created.
  setHeatmapManager(manager: HeatmapManager) {
    this.heatmapManager = manager;
    console.log("[HeatmapUpdater] HeatmapManager connected");
  }

  async handleMessage(topic: string, payload: any) {
    if (!this.heatmapManager) {
      console.warn("[HeatmapUpdater] Message dropped: HeatmapManager not connected");
      return;
    }
    if (topic !== "skopa/heatmap:batch") return;

    // Accept a raw array, or { points: [...] }.
    const points: HeatmapPoint[] = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.points)
        ? payload.points
        : [];

    this.heatmapManager.updateHeatmapBatch(points);
  }

  destroy() {
    this.heatmapManager = null;
  }
}
